import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

// Minimal range-input wrapper. The shadcn library's slider wraps
// @radix-ui/react-slider, but we only ever need a single-thumb
// value-control slider and the native input already covers that
// with proper a11y + keyboard support. Styling matches the rest of
// the form primitives (focus ring, theia thumb).
export const Slider = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="range"
    className={cn(
      'h-1.5 w-full cursor-pointer appearance-none rounded-full bg-neutral-700',
      'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 focus:ring-offset-background',
      '[&::-webkit-slider-thumb]:h-3.5 [&::-webkit-slider-thumb]:w-3.5',
      '[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full',
      '[&::-webkit-slider-thumb]:border-0 [&::-webkit-slider-thumb]:bg-theia-500',
      '[&::-webkit-slider-thumb]:transition-transform [&::-webkit-slider-thumb]:hover:scale-110',
      '[&::-moz-range-thumb]:h-3.5 [&::-moz-range-thumb]:w-3.5',
      '[&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0',
      '[&::-moz-range-thumb]:bg-theia-500',
      className,
    )}
    {...props}
  />
));
Slider.displayName = 'Slider';
